import { Controller } from "@hotwired/stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {
  initialize() {
    this.handleMount();
  }

  handleMount(element = null) {
    const target = element || this.element;
    const mainCarousel = target.querySelector(".splide--main");
    const thumbCarousel = target.querySelector(".splide--thumb");
    const filteredImages = mainCarousel.querySelectorAll("img").length;

    if (!mainCarousel)
      return console.log("There must always be a carousel in order to mount");

    let config = {
      type: filteredImages > 1 ? "loop" : "",
      pagination: false,
    };

    if (mainCarousel.parentElement.classList.contains("hero-carousel")) {
      config = {
        ...config,
        ...JSON.parse(mainCarousel.dataset.splide),
      };
    }

    const primarySlider = new Splide(mainCarousel, {
      ...config,
    });

    if (thumbCarousel) {
      const thumbSlider = new Splide(thumbCarousel, {
        ...config,
        perPage: Math.min(filteredImages, 4),
        width: 80 * Math.min(filteredImages, 4),
      }).mount();

      primarySlider.sync(thumbSlider).mount();
    } else {
      primarySlider.mount();
    }
  }
}
